import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Process from './components/Process/Process';
// import Cases from './components/Cases/Cases';
import Principles from "./components/Principles/Principles";
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import StickyCall from "./components/StickyCall/StickyCall";
import './styles/global.scss';


// Test comment
function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services />
      <Process />
      {/* <Cases /> */}
      <Principles />
      <Contact />
      <Footer />
      <StickyCall />
    </div>
  );
}

export default App;
